import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import './Team.css';

const TELEGRAM_URL = 'https://t.me/justdisplay';

const contacts = [
  {
    name: 'Глеб Пряхин',
    role: 'CEO',
    email: 'gleb@performerai.ru',
  },
  {
    name: 'Диана Фахритдинова',
    role: 'CMO',
    email: 'diana@performerai.ru',
  },
];

const Team = () => {
  const [ref, inView] = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });

  return (
    <section className="team" id="contacts" ref={ref}>
      <motion.div
        className="team-container"
        initial={{ opacity: 0 }}
        animate={inView ? { opacity: 1 } : {}}
        transition={{ duration: 0.8 }}
      >
        <motion.h2
          className="section-title team-title"
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          Контакты
        </motion.h2>

        <motion.div
          className="team-layout"
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, delay: 0.35 }}
        >
          <div className="team-photo-wrap">
            <img
              src="/images/team.png"
              alt="Команда PerformerAI"
              className="team-photo"
            />
          </div>

          <div className="team-contacts">
            {contacts.map((person) => (
              <div key={person.email} className="team-contact-item">
                <h3 className="team-contact-name">{person.name}</h3>
                <p className="team-contact-role">{person.role}</p>
                <a href={`mailto:${person.email}`} className="team-contact-email">
                  {person.email}
                </a>
              </div>
            ))}

            <a
              href={TELEGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="team-contact-button"
            >
              Написать
            </a>
          </div>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default Team;
